// Axios instance
import Cookies from 'js-cookie';
import axios, {
  AxiosResponse,
  AxiosError,
  InternalAxiosRequestConfig,
  AxiosRequestHeaders,
} from 'axios';

const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

const requestHandler = (request: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const token = Cookies.get('token');
  if (token) {
    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${token}`,
    } as AxiosRequestHeaders;
  }
  return request;
};

const responseHandler = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const errorHandler = (error: AxiosError): Promise<never> => {
  if (error.response && error.response.status === 401) {
    Cookies.remove('token');
    window.location.href = "/auth";
  }
  return Promise.reject(error);
};

http.interceptors.request.use(requestHandler, errorHandler);
http.interceptors.response.use(responseHandler, errorHandler);

export default http;
